<template>
  <div class="dialog">
    <div class="dialog__trigger" @click="open">
      <!-- 触发弹窗 -->
      <slot name="trigger" />
    </div>
    <el-dialog
      :visible.sync="visible"
      :custom-class="customClass"
      :center="center"
      :append-to-body="true"
      :width="width"
      :close-on-click-modal="clickModalClose"
      class="dialog-box"
      :before-close="close"
    >
      <!-- 弹窗内容 -->
      <template v-if="title" #title>{{ title }}</template>
      <!-- 自定义内容 -->
      <slot>{{ content }}</slot>
      <!-- 底部弹窗页脚 -->
      <template #footer>
        <div class="dialog-footer">
          <el-button
            v-if="cancelButtonText"
            size="small"
            @click="handleEvent('cancel')"
          >
            {{ cancelButtonText }}
          </el-button>
          <el-button
            v-if="confirmButtonText"
            size="small"
            type="primary"
            @click="handleEvent('confirm')"
          >
            {{ confirmButtonText }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      // 弹窗标题
      type: String,
      default: "",
    },
    content: {
      // 弹窗内容
      type: String,
      default: "",
    },
    confirmButtonText: {
      // 确认按钮内容
      type: [String, Boolean],
      default: "确定",
    },
    cancelButtonText: {
      // 取消按钮内容
      type: [String, Boolean],
      default: "取消",
    },
    width: {
      // 弹窗的宽度
      type: String,
      default: "400px",
    },
    disabled: {
      // 是否禁用
      type: Boolean,
      default: false,
    },
    async: {
      // 是否开启异步关闭
      type: Boolean,
      default: false,
    },
    clickModalClose: {
      // 点击遮罩层关闭对话窗口
      type: Boolean,
      default: false,
    },
    center: {
      // 是否居中布局
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    handleEvent(type) {
      this.$emit(type);
      if (!this.async || type === "cancel") {
        this.close();
      }
    },

    close() {
      this.visible = false;
      this.$nextTick(() => {
        this.$emit("close");
      });
    },
    open() {
      if (this.disabled) {
        return;
      }
      this.visible = true;
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-body {
  white-space: pre-line;
}
.dialog-box ::v-deep {
  .el-dialog__body {
    padding: 10px 20px;
  }
}
.dialog-footer {
  .el-button--default {
    background: #f2f3f5;
    height: 30px;
    min-width: 70px;
    border-radius: 6px;
    padding: 0 15px;
    border: none;
    font-weight: 500;
    font-size: 14px;
    color: #4e5969;
    background: #ffffff;
  }
  .el-button--default:focus,
  .el-button--default:hover {
    background: #f2f3f5;
    border: unset;
  }
  .el-button--primary {
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    height: 30px;
    min-width: 70px;
    border-radius: 6px;
    padding: 0 15px;
    border: none;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }
  .el-button--primary:focus,
  .el-button--primary:hover {
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%) !important;
    border: unset;
  }
}
</style>
